module.exports = __webpack_public_path__ + "static/media/arvind.21de9cad.png";